/* O SISTEMA DE TRABALHO DO BACKOFFICE (Douglas 22/10/2026, protótipo aprovado):
   BKO e analista abrem o CRM direto na triagem da função e o menu mostra só o
   trabalho dela. As telas continuam existindo para a gestão; os botões das
   triagens são os mesmos. O Kanban fica porque Aceite, Input, Pendência de
   input, Aguardando HP e Pedido recuperado ainda só abrem por ele. */

type Funcao = 'BKO_CONTRATO' | 'BKO_INPUT' | 'BKO_TRAMITACAO' | 'BKO_PORTABILIDADE'
  | 'ANALISTA_QUALIDADE';

const MENU_BASE = ['WhatsApp Inbox', 'Minha fila', 'Kanban', 'Triagens', 'Tarefas', 'Minha Performance', 'Avisos', 'RH & Pessoas'];

const SISTEMA: Record<Funcao, { casa: string; menu: string[] }> = {
  BKO_CONTRATO: { casa: 'pedido_fechado', menu: [...MENU_BASE, 'Planilha'] },
  BKO_INPUT: { casa: 'erro_solar', menu: [...MENU_BASE, 'Planilha'] },
  BKO_TRAMITACAO: { casa: 'erro_solar', menu: [...MENU_BASE, 'Planilha'] },
  BKO_PORTABILIDADE: { casa: 'inspecao_concluida', menu: [...MENU_BASE, 'Planilha', 'Oportunidades'] },
  // A analista única é dona do ciclo inteiro dos pedidos dela (Douglas 27/10/2026).
  ANALISTA_QUALIDADE: { casa: 'esim', menu: [...MENU_BASE, 'Planilha', 'Faturas', 'Oportunidades'] },
};

export function sistemaDeTrabalho(funcao: string | null | undefined) {
  return funcao && funcao in SISTEMA ? SISTEMA[funcao as Funcao] : null;
}

/** A casa é a Minha fila (Douglas 24/10/2026): ela leva ao que vence primeiro. */
export function casaDoSistemaDeTrabalho(funcao: string | null | undefined): string | null {
  return sistemaDeTrabalho(funcao) ? '/minha-fila' : null;
}

/** A triagem principal da função (a casa de antes da Minha fila). */
export function triagemDaFuncao(funcao: string | null | undefined): string | null {
  const s = sistemaDeTrabalho(funcao);
  return s ? `/triagens?triagem=${s.casa}` : null;
}
